export default __webpack_public_path__ + "static/spot-illos-dark-e103c18f317992cdacab8a8a30376502f776518cdd6175d15c7e35da727c7c5e.png";